// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles_modal__3Jh76","topBorder":"styles_topBorder__MOQtn"};